import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  features?: string[];
  color?: 'purple' | 'amber' | 'blue' | 'green' | 'orange' | 'cyan' | 'pink' | 'indigo';
  className?: string;
}

const slateStyle = {
  bg: 'bg-slate-800/80 border border-slate-700/60',
  border: 'hover:border-slate-600',
  icon: 'text-slate-200',
  dot: 'bg-slate-400',
};

const emeraldStyle = {
  ...slateStyle,
  icon: 'text-emerald-400',
  dot: 'bg-emerald-400',
};

export function FeatureCard({
  icon: Icon,
  title,
  description,
  features = [],
  color = 'purple',
  className,
}: FeatureCardProps) {
  const colors = color === 'green' ? emeraldStyle : slateStyle;

  return (
    <div
      className={cn(
        'group relative bg-white/[0.03] backdrop-blur-xl rounded-2xl p-6 border border-white/10 transition-all duration-300 hover:shadow-[0_20px_50px_rgba(0,0,0,0.5)]',
        colors.border,
        className
      )}
    >
      <div className="relative z-10">
        <div
          className={cn('w-12 h-12 rounded-xl flex items-center justify-center mb-4', colors.bg)}
        >
          <Icon className={cn('w-6 h-6', colors.icon)} />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        <p className="text-white/90 text-sm mb-4">{description}</p>
        {features.length > 0 && (
          <ul className="space-y-1">
            {features.map((feature, i) => (
              <li key={i} className="text-xs text-white/90 flex items-center gap-2">
                <div className={cn('w-1 h-1 rounded-full', colors.dot)} />
                {feature}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default FeatureCard;
